import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api
      .get("/orders/my")
      .then(({ data }) => setOrders(data))
      .finally(() => setOrdersLoading(false));
  }, [user]);

  if (loading) return <div className="pt-32 px-6 text-sm text-[#666]">Loading…</div>;
  if (!user) {
    return (
      <div className="pt-32 pb-24">
        <div className="max-w-md mx-auto px-6 text-center">
          <h1 className="font-display text-3xl font-extrabold tracking-tighter">
            Please sign in
          </h1>
          <Link
            to="/login"
            className="inline-block mt-8 bg-[#111] text-white px-8 py-4 text-sm font-medium"
          >
            Sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="label-eyebrow mb-4">Account</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter">
          Hello, {user.name.split(" ")[0]}.
        </h1>
        <p className="mt-4 text-[#666]">{user.email}</p>

        <div className="mt-16">
          <div className="label-eyebrow mb-6">Order History</div>
          {ordersLoading ? (
            <div className="text-sm text-[#666]">Loading orders…</div>
          ) : orders.length === 0 ? (
            <div className="text-sm text-[#666]" data-testid="no-orders">
              No orders yet.
            </div>
          ) : (
            <ul className="space-y-6">
              {orders.map((o) => (
                <li
                  key={o.id}
                  className="border border-[#e5e5e5] p-6"
                  data-testid={`order-${o.id}`}
                >
                  <div className="flex flex-wrap justify-between gap-3 items-start">
                    <div>
                      <div className="text-xs text-[#666] uppercase tracking-widest">
                        Order #{o.id.slice(0, 8).toUpperCase()}
                      </div>
                      <div className="text-sm text-[#666] mt-1">
                        {new Date(o.created_at).toLocaleDateString()}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-display font-bold">₹{o.total.toFixed(2)}</div>
                      <div className="text-xs uppercase tracking-widest text-[#666] mt-1">
                        {o.status} · {o.payment_status}
                      </div>
                    </div>
                  </div>
                  <ul className="mt-4 space-y-1 text-sm text-[#666]">
                    {o.items.map((it, idx) => (
                      <li key={idx}>
                        {it.name} · Size {it.size}{it.color ? ` · ${it.color}` : ""} × {it.quantity}
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
